export const TableHelpers = {
    data() {
        return {
            tableColumns: [{
                    title: 'Expediente',
                    type: 'custom-html',
                    key: 'accreditation_applications',
                    modifier: (item) => {
                        return `<a href="/accreditations/applications/${item.id}" target="_blank">${item.record || ''}</a>`;
                    }
                },
                {
                    title: 'Tipo de Acreditacion',
                    type: 'custom-html',
                    key: 'accreditation_applications',
                    modifier: (item) => {
                        return item.accreditation_type.name;
                    }
                },
                {
                    title: 'OEC',
                    type: 'custom-html',
                    key: 'accreditation_applications',
                    modifier: (item) => {
                        return item.organization.name;
                    }
                },
                {
                    title: 'Tipo',
                    type: 'custom-html',
                    key: 'type',
                    modifier: (item) => {
                        return item == 'E' ? 'Evaluacion' : 'Testificacion';
                    }
                },
                {
                    title: 'Código',
                    type: 'text',
                    key: 'code',
                },
                // {
                //     title: 'Días transcurridos',
                //     type: 'custom-html',
                //     key: 'date_start',
                //     modifier: (item) => {
                //         const dateNow = new Date();
                //         if (moment(dateNow).format() < moment(item).add('days',5).format()) {
                //             return `<span class="badge badge-sm badge-pill badge-success">${(moment(dateNow).format()).diff(moment(item).format(), 'days')}</span>`
                //         } else {
                //             return `<span class="badge badge-sm badge-pill badge-danger">-${moment(dateNow).diff(moment(item).add('days',5), 'days')}</span>`
                //         }
                        
                //     }
                // },
                
            ],
            actionObj: {
                title: this.$t('action'),
                type: 'action',
            }
        }
    },
}